/* eslint-disable */

const mutations = {
  updateStructuresList(state, structuresList) {
    state.list = structuresList.sort((s, s1) => {
      return s.creationDate > s1.creationDate ? 1 : -1
    });
  }
};

export default mutations;
